import { supabaseClient } from "@/lib/supabase";
import type { KnockMessage } from "@/types/zod/knock";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";

interface GetUserMessagesResponse {
	items: KnockMessage[];
	page_info: {
		__typename: string;
		after: string | null;
		before: string | null;
		page_size: number;
		total_count: number;
	};
}

async function getUserMessages(
	userId: string,
): Promise<GetUserMessagesResponse> {
	try {
		const { data, error } = await supabaseClient.functions.invoke(
			"public-get-user-messages",
			{
				method: "POST",
				body: { userId },
			},
		);

		if (error) {
			console.error("Failed to fetch messages:", error);
			throw new Error("Failed to fetch messages");
		}

		return data;
	} catch (error) {
		console.error("Error fetching messages:", error);
		toast.error("Failed to load messages");
		return {
			items: [],
			page_info: {
				__typename: "PageInfo",
				after: null,
				before: null,
				page_size: 50,
				total_count: 0,
			},
		};
	}
}

export function useGetUserMessagesQuery(userId: string) {
	const isProd = window.location.hostname === "patient-watch.com"|| window.location.hostname === "app.patient-watch.com";
	
	return useQuery({
		queryKey: ["user-messages", userId],
		queryFn: () => getUserMessages(userId),
		enabled: !!userId && isProd,
		retry: 1,
	});
}
